import { AlertCircle, CheckCircle2, Info } from "lucide-react";

import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from ".";
import { useToast } from "./useToast";

const VARIANT_ICONS = {
  default: Info,
  destructive: AlertCircle,
  success: CheckCircle2,
} as const;

/** Tinted icon chip shown at the start of each toast, keyed by variant. */
const ICON_CHIP_CLASSES = {
  default: "bg-primary/10 text-primary",
  destructive: "bg-destructive/15 text-destructive",
  success: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
} as const;

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const resolvedVariant = variant ?? "default";
        const Icon = VARIANT_ICONS[resolvedVariant] ?? Info;

        return (
          <Toast
            key={id}
            variant={variant}
            {...props}
          >
            <span
              className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full ${ICON_CHIP_CLASSES[resolvedVariant] ?? ICON_CHIP_CLASSES.default}`}
              aria-hidden="true"
            >
              <Icon className="h-4 w-4" />
            </span>
            <div className="grid min-w-0 flex-1 gap-1 pt-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
